import React from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import Task from './Task';

const HousekeeperColumn = ({ housekeeper, handleEditTask }) => {
    const workingDuration = housekeeper.tasks.reduce(
        (min, task) => min + +task.duration,
        0
    );
    const workingHours = Math.floor(workingDuration / 60);
    const workingMins = workingDuration - workingHours * 60;

    return (
        <Droppable droppableId={`housekeeper-${housekeeper.id}`}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                        background: snapshot.isDraggingOver
                            ? '#ffcd9e'
                            : '#fef2e8',
                        padding: 16,
                        minHeight: '100%',
                    }}
                >
                    <h3 style={{ marginBottom: 8, textAlign: 'center' }}>
                        {housekeeper.name}
                    </h3>
                    <h4 style={{ marginBottom: 4 }}>
                        Total time: {`${workingHours} hour ${workingMins} min`}
                    </h4>
                    <h4 style={{ marginBottom: 8 }}>
                        Tasks in other hubs:{' '}
                        {housekeeper.tasksCount - housekeeper.tasks.length}
                    </h4>
                    {housekeeper.tasks.map((task, index) => (
                        <Task
                            key={task.id}
                            task={task}
                            index={index}
                            taskType={`housekeeper-${housekeeper.id}`}
                            handleEditTask={handleEditTask}
                        />
                    ))}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    );
};

HousekeeperColumn.propTypes = {
    housekeeper: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
        name: PropTypes.string.isRequired,
        tasks: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                    .isRequired,
                title: PropTypes.string.isRequired,
                hotelApartment: PropTypes.string,
                duration: PropTypes.string,
                deadline: PropTypes.string,
            })
        ),
        tasksCount: PropTypes.number.isRequired,
    }).isRequired,
    handleEditTask: PropTypes.func.isRequired,
};

export default HousekeeperColumn;
